import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { InsightEventGroupEnum } from "./constants";

interface InsightTabState {
	activeCategoryTab: InsightEventGroupEnum;
	setActiveCategoryTab: (tab: InsightEventGroupEnum) => void;
}

export const useInsightTabStore = create<InsightTabState>()(
	devtools(
		(set) => ({
			activeCategoryTab: InsightEventGroupEnum.Offensive,
			setActiveCategoryTab: (tab: InsightEventGroupEnum) => {
				// Update immediately - this is a synchronous, non-blocking update
				set({ activeCategoryTab: tab });
			},
		}),
		{
			//@ts-ignore
			enabled: import.meta.env.DEV,
			name: "insight-tab-store",
		},
	),
);
